export interface tillproductoptions {
    id: string | null;
    name: string;
    disabled: boolean;
    venueid: string;
    colour: string;
    price: number;
    qty: number;
  }

  export class cTillproductoptions implements tillproductoptions {
    id: string | null;
    name: string;
    disabled: boolean;
    venueid: string;
    colour: string;
    price: number;
    qty: number;

    constructor(data?: Partial<tillproductoptions>) {
      this.id = data?.id ?? null;
      this.name = data?.name ?? '';
      this.disabled = data?.disabled ?? false;
      this.venueid = data?.venueid ?? '';
      this.colour = data?.colour ?? '';
      this.price = data?.price ?? 0;
      this.qty = data?.qty ?? 0;
    }
  }
